import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgMaterialSymbolsArrowDropDown = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path fill="currentColor" d="m12 15-5-5h10z" />
  </svg>
);
const ForwardRef = forwardRef(SvgMaterialSymbolsArrowDropDown);
const Memo = memo(ForwardRef);
export default Memo;
